'use strict';

angular.module('cimerFrontEndApp').service('Position',['$q','$http','ApiUrl',
  function($q,$http,ApiUrl) {
    var _apiUrl=ApiUrl.url('/Position/');

    return {
      getPositions: function() {
        var deferred = $q.defer();
        var self = this;

        var data = {
          cache: true
        };

        $http.get(_apiUrl + 'GetAllPositions',data).then(function (response){
          self.positions=response.data;
          deferred.resolve();
        }, function (err){
          self.positions=null;
          deferred.reject(err);
        });

        return deferred.promise;
      },
      positions:null
    };
  }]);
